module.exports = __webpack_public_path__ + "assets/img/btn-detail-a7be05b5.png";